'use client'

import { ReactNode, useCallback, useMemo } from 'react'
import { signOut } from 'next-auth/react'

import { useDeliveryAddressAdapter } from 'modules/cart'
import {
  AccountPort,
  CustomerPorts,
  CustomerPortsProvider
} from 'modules/customer'
import { useDeliverySupport } from 'modules/delivery'
import { useInvoiceAddressAdapter } from 'modules/saleOrders'
import { PATHS } from 'shared/utils/paths'

const useAccountAdapter = (): AccountPort => {
  const { clearPostalCode } = useDeliverySupport()

  const onAccountDeleted = useCallback(async () => {
    await signOut({ callbackUrl: PATHS.home }).then(() => {
      clearPostalCode()
    })
  }, [clearPostalCode])

  return useMemo(() => ({ onAccountDeleted }), [onAccountDeleted])
}

const customerAdapters: CustomerPorts = {
  useDeliveryAddress: useDeliveryAddressAdapter,
  useInvoiceAddress: useInvoiceAddressAdapter,
  useAccount: useAccountAdapter
}

export const CustomerAdaptersProvider = ({ children }: { children: ReactNode }) => (
  <CustomerPortsProvider ports={customerAdapters}>
    {children}
  </CustomerPortsProvider>
)
